
import { supabase } from "@/integrations/supabase/client";
import { Category } from "@/types/reagent.types";
import { toast } from "sonner";

const DEFAULT_CATEGORIES = [
  { id: "chemicals", name: "Chemicals" },
  { id: "antibodies", name: "Antibodies" },
  { id: "enzymes", name: "Enzymes" },
  { id: "biological-samples", name: "Biological Samples" },
  { id: "other", name: "Other" }
];

/**
 * Fetches all available reagent categories from the database
 */
export const fetchCategories = async (): Promise<Array<{ id: string, name: string }>> => {
  console.log("Fetching categories from the database");
  
  // Return default categories immediately to prevent UI blocking
  const defaultCategories = [...DEFAULT_CATEGORIES];
  
  try {
    // Fetch actual categories from database
    const { data, error } = await supabase
      .from("categories")
      .select("id, name")
      .order("name");
    
    if (error) {
      console.error("Error fetching categories:", error);
      toast.error("Error loading categories: " + error.message);
      return defaultCategories;
    }
    
    if (!data || data.length === 0) {
      console.log("No categories found in database, using defaults");
      toast.info("No categories found, using default categories");
      return defaultCategories;
    }
    
    console.log(`Successfully fetched ${data.length} categories from database`);
    toast.success(`Loaded ${data.length} categories`);
    return data;
  } catch (error) {
    console.error("Exception in fetchCategories:", error);
    console.log("Returning default categories due to error");
    toast.error("Error loading categories, using defaults");
    return defaultCategories;
  }
};
